// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3i9B_","signatureButtonsRight":"ModalSign_signatureButtonsRight__1Wixe"};